import React from "react";
import NewContractContent from "../components/trips/new-contract-content";

const NewContract = () => {
  return <NewContractContent />;
};

export default NewContract;
